import { Link } from '@one-thd/sui-atomic-components';
import React, { useEffect } from 'react';
import { DeliveryInstructionsEdit } from '../../../../hooks/delivery-hooks';
import { catchButtonDisplayEvent } from '../../../../utils/edit-delivery-instructions/analytics';
import '../../../../styles/order-details.scss';
export var EditDeliveryInstructions = function (_a) {
    var fulfillmentGroup = _a.fulfillmentGroup, orderDetailsData = _a.orderDetailsData, handleEditDeliveryInstructions = _a.handleEditDeliveryInstructions, customerType = _a.customerType, fulfillmentGroupIndex = _a.fulfillmentGroupIndex;
    useEffect(function () {
        catchButtonDisplayEvent();
    }, []);
    var onClick = function () {
        DeliveryInstructionsEdit(fulfillmentGroup, orderDetailsData, handleEditDeliveryInstructions, customerType, fulfillmentGroupIndex); // will open EditDeliveryInstructionsDrawer
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "card-fix" },
            React.createElement(Link, { component: "button", variant: "body-base", onClick: onClick }, "Edit"))));
};
